var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var serverSidePagination = {};

serverSidePagination.oninit = function (vnode) {
  var ctrl = this;
  ctrl.url = vnode.attrs.url;
  ctrl.recordsToShow = vnode.attrs.recordsToShow;
  ctrl.parameterFieldName = vnode.attrs.parameterFieldName;
  ctrl.searchValue = vnode.attrs.searchValue;
  ctrl.onlyDirectEquipment = vnode.attrs.onlyDirectEquipment;
  ctrl.preferredNumberOfRowsValue = prop(vnode.attrs.preferredNumberOfRowsValue());
  ctrl.locationRid = vnode.attrs.locationRid;
  ctrl.allRidsLength = vnode.attrs.allRidsLength;
  ctrl.isLoading = vnode.attrs.isLoading || prop(false);

  ctrl.init = function(data) {
    ctrl.originalData = JSON.parse(JSON.stringify(data))
    ctrl.data = data;
    ctrl.data.splice(1);
    ctrl.selectedPage = prop(1);
    ctrl.numberOfPages = prop(Math.ceil(ctrl.originalData.length / ctrl.preferredNumberOfRowsValue()));
    
    var newViewArray = ctrl.originalData.slice(0, ctrl.preferredNumberOfRowsValue());
    ctrl.data.length = 0;
    ctrl.data.push(...newViewArray);
    m.redraw();
    
    ctrl.firstPage = function () {
      ctrl.selectedPage(1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.request((ctrl.selectedPage()-1));
    }  
    ctrl.previusPage = function () {
      ctrl.selectedPage(ctrl.selectedPage() - 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.request((ctrl.selectedPage()-1));
    }
    ctrl.nextPage = function () {
      ctrl.selectedPage(ctrl.selectedPage() + 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.request((ctrl.selectedPage()-1));
    }
    ctrl.lastPage = function () {
      ctrl.selectedPage(ctrl.numberOfPages());
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.request((ctrl.selectedPage()-1));
    }  
    ctrl.showPage = function (page) {
      ctrl.selectedPage(page);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.originalData.slice((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue(), (((ctrl.selectedPage()-1)*ctrl.preferredNumberOfRowsValue()+ctrl.preferredNumberOfRowsValue()-1)+1)));
      ctrl.request((ctrl.selectedPage()-1));
    }
  }
  ctrl.init(vnode.attrs.data);

  ctrl.request = function(pageNumber) {
    ctrl.isLoading(true);
    let parameters = {}
    parameters[ctrl.parameterFieldName] = pageNumber;
    parameters['search'] = ctrl.searchValue();
    parameters['onlyDirectEquipment'] = ctrl.onlyDirectEquipment;
    parameters['preferredNumberOfRowsValue'] = ctrl.preferredNumberOfRowsValue();
    parameters['locationRid'] = ctrl.locationRid;
    loaders.requestWithLoader({
      url: ctrl.url,
      params: parameters,
      method: 'GET',
      background: true
    })
    .then( data => {
      ctrl.recordsToShow(data);
      if (vnode.attrs.callbackFunction) { vnode.attrs.callbackFunction(); }
    })
    .finally(() => {
      ctrl.isLoading(false);
      m.redraw();
    });
  }
}

serverSidePagination.onupdate = function(vnode) {
  var ctrl = this;
  ctrl.url = vnode.attrs.url;
  if (ctrl.preferredNumberOfRowsValue() != vnode.attrs.preferredNumberOfRowsValue() || vnode.attrs.url != ctrl.url) {
    ctrl.preferredNumberOfRowsValue = prop(vnode.attrs.preferredNumberOfRowsValue());
    ctrl.init(vnode.attrs.data);
  }

  if (ctrl.originalData.length != vnode.attrs.data.length ) {
    ctrl.init(vnode.attrs.data);
  }
}

serverSidePagination.view = function(vnode) {
  var ctrl = this;
  let smallScreen = false;
  
  return m('div.w-100',{
    id: 'tab-pagination-container'+ctrl.originalData.length
  },[
    (()=>{
      if (
        document.getElementById('tab-pagination-container'+ctrl.originalData.length) && 
        document.getElementById('tab-pagination-container'+ctrl.originalData.length).clientWidth < 720
      ) {
        smallScreen = true;
      }
      if (ctrl.numberOfPages()>1) {
        return m('div.flex.flex-wrap',[
            function() {
              if (ctrl.numberOfPages()>1) {
                return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mb1', {
                  onclick: function(e) {
                    if (ctrl.selectedPage()!=1) {
                      ctrl.firstPage()
                    }
                  }
                }, [
                  m('span', {'aria-hidden':'true'}, '«'),
                ])
              }
            }(),
            m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1', {
              onclick: function(e) {
                if (ctrl.selectedPage()!=1) {
                  ctrl.previusPage()
                }
              }
            }, [
              m('span', {'aria-hidden':'true'}, '<'),
            ]),
            function() {
              var tabs=[]
              var list = function(page) {
                return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1'+ (ctrl.selectedPage() == page ? ' bg-mid-gray' : ''), {
                  onclick: function(e){
                    ctrl.showPage(page)
                  }
                },[
                  m('span', {'aria-hidden':'true'}, page),
                ])
              }
              if (!smallScreen && ctrl.numberOfPages()<=7) {
                for (var i=0; i<ctrl.numberOfPages();i++) {
                  tabs.push(list(i+1))
                }
                return tabs
              } else if (!smallScreen) {
                if (ctrl.selectedPage()<4) {
                  for (var i=0; i<7;i++) {
                    tabs.push(list(i+1))
                  } 
                  return tabs
                }
                if (ctrl.selectedPage()>3 && (ctrl.numberOfPages()-2)>ctrl.selectedPage()) {
                  tabs.push(list(ctrl.selectedPage()-3))
                  tabs.push(list(ctrl.selectedPage()-2))
                  tabs.push(list(ctrl.selectedPage()-1))
                  tabs.push(list(ctrl.selectedPage()))
                  tabs.push(list(ctrl.selectedPage()+1))
                  tabs.push(list(ctrl.selectedPage()+2))
                  tabs.push(list(ctrl.selectedPage()+3))
                  return tabs
                }
                if ((ctrl.numberOfPages()-3)<ctrl.selectedPage()) {
                  for (var i=6; i>=0;i--) {
                    tabs.push(list(ctrl.numberOfPages()-i))
                  } 
                  return tabs
                }
              } else {
                tabs.push(list(ctrl.selectedPage()))
                return tabs
              }
            }(),
            m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1', {
              onclick: function(e) {
                if (ctrl.selectedPage()!=ctrl.numberOfPages()) {
                  ctrl.nextPage();
                }
              }
            },[
              m('span', {'aria-hidden':'true'}, '>'),
            ]),
            function() {
              if (ctrl.numberOfPages()>1) {
                return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1', {
                  onclick: function(e) {
                    if (ctrl.selectedPage()!=ctrl.numberOfPages()) {
                      ctrl.lastPage()
                    }
                  }
                },[
                  m('span', {'aria-hidden':'true'}, '» ' + ctrl.numberOfPages()),
                ])
              }
            }(),
            m('div.flex.items-center.ml2.pv1', [
              m('label.mr2.moon-gray.f4', 'Total:'),
              m('div.br2.nowrap.mr2.pv1', {style: {'background-color': '#262626'}},[
                m('label.f4.ph1.moon-gray', `${ctrl.originalData.length}`)            
              ])
            ])
        ])
      } else {
        return m('div')
      }
    })()
  ])
}

module.exports = serverSidePagination;

